module.exports = require("../../bundled/xlsx");